import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';
import { Image, Link } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export interface AriaLabel {
  close: string;
}

export interface Icon {
  path: string;
  alt: string;
}

export interface Tag {
  title: string;
  image: Image;
}

export interface Images extends Image {
  label?: GenericLabel;
}

export interface MicroMoments extends DisplayProperties {
  id: string;
  actionId?: string;
  logo: Images;
  title: string;
  description?: string;
  action?: Link;
  close: Icon;
  tag?: Tag;
  ariaLabel: AriaLabel;
}
